import React from "react"
import { StyleSheet, Text, View } from "react-native"
import { theme } from "@common/theme/theme"
import IconDisc from "../components/IconDisc"
import InscriptionSheet from "../components/InscriptionSheet"
import { inscriptionGuarantees } from "../constants/inscriptionContent"

/**
 * « Toutes les garanties », ouvert depuis les trois que l'écran montre : une
 * liste à plat dans le volet du funnel. Pas la carte « Vos garanties » des
 * autres checkouts (`NewSubscriptionGuaranteesCard`) : son fond dégradé dans
 * un volet faisait cheap, c'est ce qui a été demandé de retirer ici. La liste
 * suit l'engagement que dit le devis.
 */
const ReservationGuaranteesSheet = ({ isVisible, onClose, withCommitment }) => (
    <InscriptionSheet
        isVisible={isVisible}
        onClose={onClose}
        title="Toutes les garanties"
    >
        <View>
            {inscriptionGuarantees(withCommitment).map((guarantee, i) => (
                <View
                    key={guarantee.label}
                    style={[styles.row, i > 0 && styles.rowBelow]}
                >
                    <IconDisc name={guarantee.icon} />
                    <View style={styles.text}>
                        <Text style={styles.label}>{guarantee.label}</Text>
                        <Text style={styles.subtitle}>
                            {guarantee.subtitle}
                        </Text>
                    </View>
                </View>
            ))}
        </View>
    </InscriptionSheet>
)

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 12,
        paddingVertical: 12,
    },
    rowBelow: {
        borderTopWidth: 1,
        borderTopColor: theme.colors.lighter,
    },
    text: { flex: 1, gap: 2 },
    label: {
        fontFamily: "Montserrat-Bold",
        fontSize: 14,
        lineHeight: 19,
        color: theme.colors.primaryDark || theme.colors.primary,
    },
    subtitle: {
        fontFamily: "Montserrat-Regular",
        fontSize: 13,
        lineHeight: 19,
        color: theme.colors.greyAlt,
    },
})

export default ReservationGuaranteesSheet
